<template>
  <div id="app">
    <div class="page-wrapper">
      <div class="container">
        <h1 class="title">User Agreement</h1>
        <p>Last Updated: August 21, 2026</p>
        <p><strong>1. Definition</strong></p>
        <ul>
          <li>
            <p>
              "User" refers to an individual who accesses or uses this service.
            </p>
          </li>
          <li>
            <p>
              "Service" includes the features we provide, such as short drama
              viewing, interaction, advertisement display, and more.
            </p>
          </li>
          <li>
            <p>
              "Content" refers to all the materials provided through the service
              by us or third parties, including episodes, videos, images, text,
              audio, software, and more.
            </p>
          </li>
        </ul>
        <p><strong>2. Service Usage Rules</strong></p>
        <ul>
          <li>
            <p>
              The user must be at least 13 years old (or the minimum age as
              defined by the laws of the user's residence).
            </p>
          </li>
          <li>
            <p>
              The user commits to not using the service in any illegal,
              infringing, harassing, fraudulent, or other harmful ways.
            </p>
          </li>
          <li>
            <p>
              The user must comply with local laws and regulations and is
              responsible for their own actions.
            </p>
          </li>
        </ul>

        <p><strong>3. User Behavior and Data Collection</strong></p>
        <ul>
          <li>
            <p>
              We may record your actions on the platform, including but not
              limited to: viewing history and preferences, search keywords,
              click and interaction behaviors, recharge or advertisement click
              behaviors, device information, IP address, advertisement
              identifiers (e.g., IDFA/GAID), etc.
            </p>
          </li>
          <li>
            <p>
              We will collect, store, and use your personal data in accordance
              with our <strong>Privacy Policy</strong>.
            </p>
          </li>
          <li>
            <p>By using the service, you agree to our data processing terms.</p>
          </li>
        </ul>

        <p><strong>4. Intellectual Property</strong></p>
        <ul>
          <li>
            <p>
              All content in the service (unless explicitly stated as
              user-uploaded) is owned by us or the content providers and is
              protected by copyright, trademark, and other relevant laws.
            </p>
          </li>
          <li>
            <p>
              Without authorization, users may not copy, distribute, rent, sell,
              or commercially use any content from the service.
            </p>
          </li>
          <li>
            <p>
              The user agrees to grant us a global, non-exclusive, royalty-free
              license for any content uploaded during the use of the service,
              for product promotion, display, and service optimization purposes.
            </p>
          </li>
        </ul>

        <p><strong>5. Advertisements and Third-Party Services</strong></p>
        <ul>
          <li>
            <p>
              This service may contain advertisements provided by us or third
              parties. You understand and accept the display of such content.
            </p>
          </li>
          <li>
            <p>
              Some services rely on third-party SDKs (such as Facebook, Google,
              Appsflyer, etc.) to implement functions and attribution. Please
              refer to our <strong>Privacy Policy</strong> for details.
            </p>
          </li>
          <li>
            <p>
              The use of third-party links and services is subject to their
              respective terms of service and privacy policies.
            </p>
          </li>
        </ul>

        <p><strong>6. Service Changes and Interruptions</strong></p>
        <ul>
          <li>
            <p>
              We have the right to change, suspend, or terminate part or all of
              the services (including paid services) at any time.
            </p>
          </li>
          <li>
            <p>
              If the service is interrupted or data is lost due to force majeure
              or third-party reasons, we will make reasonable efforts to assist
              in recovery, but we are not liable for any losses resulting from
              such interruptions.
            </p>
          </li>
        </ul>

        <p><strong>7. Disclaimer</strong></p>
        <ul>
          <li>
            <p>
              This service is provided on an "as-is" basis and does not
              guarantee the completeness, accuracy, or continuous availability
              of the content.
            </p>
          </li>
          <li>
            <p>
              Any losses incurred from your use of this service are at your own
              risk.
            </p>
          </li>
          <li>
            <p>
              We are not responsible for any disputes between users or between
              users and third parties.
            </p>
          </li>
        </ul>

        <p><strong>8. Governing Law and Dispute Resolution</strong></p>
        <ul>
          <li>
            <p>
              This agreement is governed by the laws of the Hong Kong Special
              Administrative Region (unless otherwise mandated by law).
            </p>
          </li>
          <li>
            <p>
              Any disputes arising from or related to this agreement should
              first be resolved through negotiation. If negotiation fails, the
              dispute should be submitted to the Hong Kong International
              Arbitration Centre for resolution.
            </p>
          </li>
        </ul>

        <p><strong>9. Miscellaneous</strong></p>
        <ul>
          <li>
            <p>
              We have the right to modify the contents of this agreement from
              time to time. Modifications will be announced within the service
              and will take effect immediately after the update.
            </p>
          </li>
          <li>
            <p>
              Operator: MAGICUBE GROUP CO., LIMITED<br>
              Registered Address: RM 1801 EASEY COMM BLDG 253-261 HENNESSY
              ROAD WANCHAI HK.<br>
              If you have any questions regarding this agreement, you may
              contact us at: magicubegroup@gmail.com
            </p>
          </li>
        </ul>

        <p><strong>10. Special Terms for Overseas Users</strong></p>
        <ul>
          <li>
            <p>
              To comply with the laws and regulations of different countries and
              regions, we provide the following additional terms for users
              residing in the EU, UK, Switzerland, California, and other
              applicable jurisdictions. If you are a user from any of these
              regions, these terms apply to you and take precedence over other
              terms.
            </p>
          </li>
          <li>
            <p>
              <strong>Data Controller Description:</strong> Magicube Group Co.,
              Limited (Registered Address: RM 1801 EASEY COMM BLDG 253-261
              HENNESSY ROAD WANCHAI HK.) is the entity responsible for
              processing your personal data on our platform.
            </p>
          </li>
          <li>
            <p>
              <strong>EU (GDPR), UK, and Switzerland User Rights:</strong>
              Including the rights to access, correct, delete, restrict
              processing, object to processing, withdraw consent, and data
              portability.
            </p>
          </li>
          <li>
            <p>
              <strong>California Residents' Rights (CCPA):</strong> Including
              the rights to know, delete, and the right not to be discriminated
              against.
            </p>
          </li>
          <li>
            <p>
              <strong>International Data Transfers:</strong> Data may be
              transferred to overseas servers and protected by contractual
              safeguards.
            </p>
          </li>
          <li>
            <p>
              <strong>Localized Content and Language Adaptation:</strong> We may
              provide specific content, rules, and language versions based on
              your country of residence.
            </p>
          </li>
        </ul>

        <p>
          <strong>11. Language of Terms and Priority of Interpretation</strong>
        </p>
        <ul>
          <li>
            <p>
              If this agreement provides versions in multiple languages, it is
              for the convenience of the user. In case of any ambiguity or
              conflict, the English version shall prevail. If you are a user
              from mainland China, the Chinese version shall prevail.
            </p>
          </li>
        </ul>

        <p><strong>12. In-App Purchases and Subscription Terms</strong></p>
        <p>
          <strong>A. Google Play Subscription and In-App Purchase Special
            Terms</strong>
        </p>
        <ul>
          <li>
            <p>
              <strong>Subscription Service Description:</strong> If you
              subscribe to the membership services, episode packages, or virtual
              content offered within the app via the Google Play Store, the
              related fees will be charged through your Google account. The
              subscription will take effect immediately when you confirm the
              purchase.
            </p>
          </li>
          <li>
            <p>
              <strong>Auto-Renewal:</strong> Unless you cancel the subscription
              at least 24 hours before the end of the current billing cycle, the
              subscription will automatically renew and will be charged
              automatically via Google Play.
            </p>
          </li>
          <li>
            <p>
              <strong>Manage Subscription and Cancellation:</strong> You can
              manage or cancel the subscription in Google Play Store under
              "Account Settings > Subscriptions." After cancellation, you can
              continue to use the subscription until the end of the current
              period.
            </p>
          </li>
          <li>
            <p>
              <strong>Refund Policy:</strong> Except where required by law, all
              completed subscription payments are non-refundable. We encourage
              you to carefully read the product description before purchasing.
            </p>
          </li>
          <li>
            <p>
              <strong>In-App Purchase Description:</strong> The app offers
              virtual content that can be purchased one-time (such as coins,
              single episode unlocks, ad removal, etc.), and once payment is
              completed, it is considered delivered. Virtual goods are
              non-transferable, non-refundable, and cannot be exchanged for
              cash.
            </p>
          </li>
        </ul>

        <p>
          <strong>B. Apple App Store Subscription and In-App Purchase Special
            Terms</strong>
        </p>
        <ul>
          <li>
            <p>
              <strong>Payment via Apple ID:</strong> All subscription and
              one-time purchase items will be billed through the Apple ID
              account linked to your device. The purchase transaction must be
              completed and confirmed via Apple's payment system.
            </p>
          </li>
          <li>
            <p>
              <strong>Auto-Renewal Mechanism:</strong> Unless you turn off the
              auto-renewal feature at least 24 hours before the current
              subscription cycle ends, the subscription will automatically renew
              and incur charges.
            </p>
          </li>
          <li>
            <p>
              <strong>Manage and Cancel Subscription:</strong> You can manage or
              cancel your subscription via "Settings > Apple ID >
              Subscriptions." After cancellation, you can continue to access the
              subscription content until the current period ends.
            </p>
          </li>
          <li>
            <p>
              <strong>Refund Policy Processed by Apple:</strong> All refund
              requests for Apple App Store in-app purchases and subscriptions
              will be handled directly by Apple. You can submit a refund request
              through Apple Support.
            </p>
          </li>
          <li>
            <p>
              <strong>Virtual Content Disclaimer:</strong> Virtual goods
              purchased within the app (such as props, unlocked content, etc.)
              are delivered immediately and are non-refundable. Virtual goods
              are only for use within this app and cannot be exchanged for cash
              or any other physical value.
            </p>
          </li>
        </ul>

        <p><strong>Ps.</strong></p>
        <ul>
          <li>
            <p>
              All in-app purchase behavior on the platform is considered as you
              having clearly understood and accepted the related terms.
            </p>
          </li>
          <li>
            <p>
              If a user violates the user agreement, engages in fraud, or abuses
              the service, the platform has the right to suspend or cancel
              subscription rights.
            </p>
          </li>
          <li>
            <p>
              The user should complete the purchase using their own legal
              payment method.
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="js">
export default {
  data() {
    return {

    }
  },
}
</script>

<style scoped lang="scss">
#app {
  background: #fff;
  padding: 80px 40px;
  min-height: 100vh;
  box-sizing: border-box;
  font-family: 'Helvetica Neue', Arial, sans-serif;
}

.page-wrapper {
  display: flex;
  justify-content: center;
}

.container {
  max-width: 960px;
  width: 100%;
}

.title {
  font-size: 36px;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin-bottom: 40px;
}

h2 {
  font-size: 24px;
  font-weight: 600;
  color: #000;
  margin: 32px 0 16px;
}

p,
li {
  color: #333;
  font-size: 16px;
  line-height: 1.8;
}

ul {
  padding-left: 24px;
  margin: 12px 0;
}

strong {
  color: #000;
}
</style>
